import { useAuthStore } from '../../../store';
import HeaderFilter from '../../../components/HeaderFilter';
import DisplayTable from '../../../components/core/DisplayTable';
import GenericForm from '../../../components/core/GenericForm';

const SectionPage = () => {
  const api = '/sections';
  const moduleName = 'Section';
  const moduleCode = 'SEC';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter showCreate={userModuleAccess?.create} />
        <DisplayTable
          api={api}
          moduleName={moduleName}
          canDelete={userModuleAccess?.delete || false}
          canEdit={userModuleAccess?.write || false}
          userRole={user?.role}
        />
        <GenericForm api={api} moduleName={moduleName} />
      </div>
    </>
  );
};

export default SectionPage;
